<div class="sp-width__full sp-row__space">
  <div class="sp-row__align">
    <mat-icon color="primary"> {{ icon }} </mat-icon>
    <h3 class="sp-color__primary sp-margin__left">
      {{ title || '' | translate }}
    </h3>
  </div>

  <div class="sp-row__align">
    <button
      (click)="see_all.emit()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left"
      [matTooltip]="'GENERAL.SEE_ALL_CTA' | translate">
      <mat-icon class="material-symbols-outlined"> chevron_right </mat-icon>
    </button>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-dark sp-margin__left"
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
